<template>
  <div class="sidebar">
    <div class="sidebar__section">
      <div class="sidebar__section--nav" v-if="item === 'personal-details'">
        <font-awesome-icon icon="user" />&nbsp;&nbsp;Personal Details
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'personal-details'">
        <routerLink to="/personal-details" active-class="active__link">
          <font-awesome-icon icon="user" />&nbsp;&nbsp;Personal Details
        </routerLink>
      </div>

      <div class="sidebar__section--nav" v-if="item === 'job-pay'">
        <font-awesome-icon icon="money-bill-wave" />&nbsp;&nbsp;Job & Pay
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'job-pay'">
        <routerLink to="/job-pay" active-class="active__link">
          <font-awesome-icon icon="money-bill-wave" />&nbsp;&nbsp;Job & Pay
        </routerLink>
      </div>

      <div class="sidebar__section--nav" v-if="item === 'document'">
        <font-awesome-icon icon="file-alt" />&nbsp;&nbsp;Document
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'document'">
        <routerLink to="/documents-upload" active-class="active__link">
          <font-awesome-icon icon="file-alt" />&nbsp;&nbsp;Document
        </routerLink>
      </div>

      <div class="sidebar__section--nav" v-if="item === 'payslip'">
        <font-awesome-icon icon="file-invoice" />&nbsp;&nbsp;Payslips
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'payslip'">
        <routerLink to="/payslip" active-class="active__link">
          <font-awesome-icon icon="file-invoice" />&nbsp;&nbsp;Payslips
        </routerLink>
      </div>

      <div class="sidebar__section--nav" v-if="item === 'leave'">
        <font-awesome-icon icon="bed" />&nbsp;&nbsp;Leave
      </div>
      <div class="sidebar__section--nav" v-if="item !== 'leave'">
        <routerLink to="/leave" active-class="active__link">
          <font-awesome-icon icon="bed" />&nbsp;&nbsp;Leave
        </routerLink>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      coreHrDropDown: false,
    };
  },
  props: ["item"],
  methods: {
    viewHrDropDown() {
      if (this.coreHrDropDown) {
        this.coreHrDropDown = false;
      } else {
        this.coreHrDropDown = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  padding-left: 29px;

  .sidebar__section {
    padding-bottom: 25px;

    .sidebar__section--nav {
      padding-bottom: 25px;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.22;
      letter-spacing: normal;
      text-align: left;
      color: #e57414;

      > span {
        color: #000000;
        cursor: pointer;

        &:hover {
          color: #e57414;
        }
      }

      > p {
        color: #e57414;
        cursor: pointer;
      }

      .sidebar__section--nav-item {
        padding-left: 30px;

        > div {
          padding-top: 20px;
          color: #000;

          > span {
            color: #e57414;
          }
        }
      }

      a {
        color: #000;
        text-decoration: none;
        &:hover {
          color: #e57414;
        }
      }
    }
  }

  .active__link {
    color: #e57414 !important;
  }
}
</style>
